import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _URL from "@babel/runtime-corejs3/core-js/url";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import { defineComponent, ref, reactive, computed } from "@vue/composition-api";
import moment from "moment";
import Amplitude from "@Shared/utils/amplitude";
import TimelineAccountCreation from "./timeline-account-creation.vue";
import TimelineFollowUp from "./timeline-follow-up.vue";
import TimelineIcon from "./timeline-icon.vue";
import TimelineEmail from "./timeline-email.vue";
import TimelineFile from "./timeline-file.vue";
import TimelineChecklist from "./timeline-checklist.vue";
import TimelineAutomation from "./timeline-automation.vue";
import TimelineNote from "./timeline-note.vue";
import TimelineClientApplicationRequest from "./timeline-client-application-request.vue";
import timelineEvent from "./timeline-event.vue";
import summarizeTimeline from "./summarize-timeline.vue";
import followUpTab from "../actions-panel/follow-up-tab.vue";
import noteTab from "../actions-panel/note-tab.vue";
import { isCurrentMonth as isCurrentMonthFn } from "@Shared/utils/helpers/dates";
import Err from "@Broker/@Routes/error";
import { kebabCase } from "lodash";
import { getMainApi } from "@Shared/@Utils/ajax";
import { formatUTC } from "@Shared/utils/helpers/dates";
import * as TimelineTypes from "./types";
import { useI18n } from "vue-i18n-composable";
import { useBootstrapModal } from "@Shared/@Composables/generic/useBootstrapModal";
export default defineComponent({
  name: "TimelineList",
  components: {
    TimelineIcon,
    TimelineAccountCreation,
    TimelineFollowUp,
    TimelineEmail,
    TimelineFile,
    TimelineChecklist,
    TimelineNote,
    TimelineClientApplicationRequest,
    TimelineAutomation,
    timelineEvent,
    summarizeTimeline,
    followUpTab,
    noteTab
  },
  props: {
    subscribers: {
      type: Array,
      default: () => []
    },
    details: {
      type: Object,
      default: () => ({})
    },
    isEmptyTimeline: Boolean,
    timelineList: {
      type: Array,
      default: () => []
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    boardId: {
      type: [String, Number],
      required: true
    },
    applications: {
      type: Object,
      default: () => ({})
    },
    clientUsername: {
      type: String,
      required: true
    },
    timelineTab: {
      type: String,
      default: ""
    }
  },
  setup(props, {
    emit,
    root
  }) {
    const actionToComponentMap = {
      [TimelineTypes.ActivityTypeE.NOTE]: "note-tab",
      [TimelineTypes.ActivityTypeE.FOLLOW_UP]: "follow-up-tab"
    };
    const {
      t,
      tc
    } = useI18n();
    const {
      modal
    } = useBootstrapModal();
    const timelinePagination = reactive({});
    const summarizationTimelineItems = ref([]);
    const suggestedActions = ref([]);
    const loadingSummary = ref(true);
    const selectedActionComponent = ref();
    const selectedActionProps = ref({});
    const selectedActionName = ref("");
    const aiActionComponent = ref();
    const store = root.$store;
    const getProfileOwner = computed(() => store.getters["BoardStore/getProfileOwner"]);
    const followUpNotificationTime = computed(() => store.state.AccountStore.accountPreferences.followUpNotificationTime);
    const getTimelineComponent = activityType => {
      if (activityType === TimelineTypes.ActivityTypeE.DRIP_CAMPAIGN_CREATION) {
        return "timeline-automation";
      }
      return `timeline-${activityType}`;
    };
    const isCurrentMonth = month => {
      return isCurrentMonthFn(month);
    };
    const toHyphens = name => {
      return kebabCase(name);
    };
    const followUpOrNote = activity => {
      return activity === TimelineTypes.ActivityTypeE.FOLLOW_UP || activity === TimelineTypes.ActivityTypeE.NOTE;
    };
    const getTooltipTitle = activity => {
      if (activity.activityType === TimelineTypes.ActivityTypeE.FOLLOW_UP) {
        return activity.complete ? formatTooltipDates(activity.updatedAt) : t("client-profile.messages.scheduledAt", {
          date: formatUTC(activity.scheduledDate),
          time: moment(activity.scheduledTime, "HH:mm").format("LT")
        });
      }
      if (activity.activityType === TimelineTypes.ActivityTypeE.NOTE) {
        return formatTooltipDates(activity.updatedAt);
      }
      return formatTooltipDates(activity.createdAt);
    };
    const formatTooltipDates = date => {
      return moment(date).format("MMM. DD, YYYY");
    };
    const getItemVariation = activity => {
      const variationFor = {
        [TimelineTypes.ActivityTypeE.EMAIL]: "0",
        [TimelineTypes.ActivityTypeE.FILE]: "-45",
        [TimelineTypes.ActivityTypeE.FOLLOW_UP]: "-30",
        [TimelineTypes.ActivityTypeE.NOTE]: "30",
        [TimelineTypes.ActivityTypeE.ACCOUNT_CREATION]: "45",
        [TimelineTypes.ActivityTypeE.AUTOMATION]: "45",
        [TimelineTypes.ActivityTypeE.CLIENT_APPLICATION_REQUEST]: "60",
        [TimelineTypes.ActivityTypeE.EVENT]: "75",
        [TimelineTypes.ActivityTypeE.CHECKLIST]: "-60",
        [TimelineTypes.ActivityTypeE.DRIP_CAMPAIGN_CREATION]: "-75"
      };
      return (variationFor[activity] || "0") + "deg";
    };
    const parseClassItem = activity => {
      const classes = {
        [TimelineTypes.ActivityTypeE.FOLLOW_UP]: "fa fa-bell-o",
        [TimelineTypes.ActivityTypeE.ACCOUNT_CREATION]: "dot-icon",
        [TimelineTypes.ActivityTypeE.NOTE]: "fa fa-file-text-o",
        [TimelineTypes.ActivityTypeE.CHECKLIST]: "fa fa-list",
        [TimelineTypes.ActivityTypeE.EMAIL]: "fa fa-envelope-o",
        [TimelineTypes.ActivityTypeE.FILE]: "fa fa-paperclip",
        [TimelineTypes.ActivityTypeE.AUTOMATION]: "fa fa-bullhorn",
        [TimelineTypes.ActivityTypeE.DRIP_CAMPAIGN_CREATION]: "fa fa-play",
        [TimelineTypes.ActivityTypeE.CLIENT_APPLICATION_REQUEST]: "fa fa-folder",
        [TimelineTypes.ActivityTypeE.EVENT]: "fa fa-calendar-o"
      };
      return classes[activity];
    };
    const pinItem = async (id, type, pinned) => {
      try {
        await store.dispatch("BoardStore/PIN_TIMELINE_ITEM", {
          profileId: props.clientProfileId,
          id,
          pinned: !pinned,
          type
        });
      } catch (e) {
        Err.handle(e);
        Amplitude.logHandledError(e);
      }
    };
    const handleIconClick = type => {
      emit("filter", type);
    };
    const getRemainingItems = sectionName => {
      var _timelinePagination$s;
      return (_timelinePagination$s = timelinePagination[sectionName]) == null ? void 0 : _timelinePagination$s.remaining;
    };
    const getFilteredItems = (sectionName, items) => {
      try {
        const paginationInfo = timelinePagination[sectionName];
        if (paginationInfo.fromItem === -1) return items;
        return _sliceInstanceProperty(items).call(items, paginationInfo.fromItem, paginationInfo.toItem);
      } catch (_unused) {
        return items;
      }
    };
    const handleDownloadToPDF = async () => {
      try {
        const response = await getMainApi({}, `/client/profile/${props.clientProfileId}/download-emails-to-pdf`);
        const pdfBlob = new Blob([Uint8Array.from(atob(JSON.parse(response)), char => char.charCodeAt(0))], {
          type: "application/pdf"
        });
        const pdfUrl = _URL.createObjectURL(pdfBlob);
        const downloadLink = document.createElement("a");
        downloadLink.href = pdfUrl;
        downloadLink.download = "All clients emails.pdf";
        downloadLink.click();
        _URL.revokeObjectURL(pdfUrl);
      } catch (error) {
        Err.handle(error);
      }
    };
    const handleSummarizeEmail = () => {
      modal.show("disclaimer-modal");
    };
    const fetchSummarizeEmail = async () => {
      var _context, _context2, _context3;
      loadingSummary.value = true;
      const response = await getMainApi({}, `/client/profile/${props.clientProfileId}/summarize-emails`);
      summarizationTimelineItems.value = _mapInstanceProperty(_context = response.summary).call(_context, (item, index) => ({
        id: index,
        emailId: item.emailId,
        date: moment(item.date).format("MMM DD, YYYY"),
        content: item.summary,
        emailBody: item.emailBody
      }));
      _sortInstanceProperty(_context2 = summarizationTimelineItems.value).call(_context2, (a, b) => b.emailId - a.emailId);
      suggestedActions.value = _mapInstanceProperty(_context3 = response.actions).call(_context3, (action, index) => _objectSpread(_objectSpread({
        id: index
      }, action), action.date ? {
        date: moment(action.date).format("MMM DD, YYYY")
      } : null));
      loadingSummary.value = false;
    };
    const cancelSummarize = () => {
      modal.hide("disclaimer-modal");
    };
    const continueSummarize = () => {
      modal.hide("disclaimer-modal");
      modal.show("summarize-modal");
      fetchSummarizeEmail();
    };
    const handleActionClick = action => {
      var _followUpNotification;
      switch (action.action) {
        case "note":
          selectedActionComponent.value = "note-tab";
          selectedActionName.value = tc("ai-email-summarization.actionNoteName");
          selectedActionProps.value = {
            formId: "ai-summarization-create-followup",
            currentTab: "note",
            note: action.text,
            clientProfileId: props.clientProfileId,
            boardId: props.boardId,
            tabData: {
              note: action.text
            },
            external: true
          };
          setTimeout(() => {
            const instancedComponent = aiActionComponent.value;
            instancedComponent == null ? void 0 : instancedComponent.init();
          }, 0);
          break;
        case "reminder":
          selectedActionComponent.value = "follow-up-tab";
          selectedActionName.value = tc("ai-email-summarization.actionReminderName");
          selectedActionProps.value = {
            formId: "ai-summarization-create-followup",
            currentTab: "follow-up",
            note: action.text,
            clientProfileId: props.clientProfileId,
            boardId: props.boardId,
            tabData: {
              description: action.text,
              assignees: [getProfileOwner.value(props.clientProfileId)],
              currentDate: moment().format("YYYY-MM-DD"),
              scheduledDate: moment(action.date).format("YYYY-MM-DD"),
              scheduledTime: (_followUpNotification = followUpNotificationTime.value) != null ? _followUpNotification : "09:00:00"
            }
          };
          setTimeout(() => {
            const instancedComponent = aiActionComponent.value;
            instancedComponent == null ? void 0 : instancedComponent.initTab();
            const descriptionValue = instancedComponent == null ? void 0 : instancedComponent.$v.description.$model;
            instancedComponent.$v.description.$model = null;
            instancedComponent.$v.description.$model = descriptionValue;
          }, 0);
          break;
      }
      modal.show("selected-action-modal");
    };
    const getSummarizationStartDate = () => {
      var _context4, _context5;
      const firstEmailGroup = _findInstanceProperty(_context4 = props.timelineList).call(_context4, group => group.items.some(item => item.activityType === TimelineTypes.ActivityTypeE.EMAIL));
      const firstEmail = firstEmailGroup == null ? void 0 : _findInstanceProperty(_context5 = firstEmailGroup.items).call(_context5, item => item.activityType === TimelineTypes.ActivityTypeE.EMAIL);
      return firstEmail ? moment(firstEmail.createdAt).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
    };
    const activityItemKey = activityItem => activityItem.activityType === TimelineTypes.ActivityTypeE.EMAIL ? `${activityItem.activityType}-${activityItem.threadId}` : `${activityItem.activityType}-${activityItem.id}`;
    return {
      timelinePagination,
      summarizationTimelineItems,
      suggestedActions,
      loadingSummary,
      selectedActionComponent,
      selectedActionProps,
      selectedActionName,
      aiActionComponent,
      modal,
      getTimelineComponent,
      isCurrentMonth,
      toHyphens,
      followUpOrNote,
      getTooltipTitle,
      formatTooltipDates,
      getItemVariation,
      parseClassItem,
      pinItem,
      handleIconClick,
      getRemainingItems,
      getFilteredItems,
      handleSummarizeEmail,
      cancelSummarize,
      continueSummarize,
      handleActionClick,
      getSummarizationStartDate,
      activityItemKey,
      t,
      tc,
      getProfileOwner,
      followUpNotificationTime,
      handleDownloadToPDF
    };
  }
});